module.exports = __webpack_public_path__ + "static/img/ivoice_banner3@2x.4f18f67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/new_home/ivoice_banner3@2x.png
// module id = 501
// module chunks = 0